import _ from 'underscore';
import FireBaseTools, {firebaseDb, firebaseApp} from '../utils/firebase';

// Driver's profile

export async function submitDriverProfileToFirebase(driverProfile) {
    const user = await FireBaseTools.fetchUser();
    const ref = firebaseDb.ref(`users/${user.uid}/profile`);
    const storageRef = firebaseApp.storage().ref(`users/${user.uid}/cv`);

    if (driverProfile.cv) {
        // CV is optional
        try {
            await storageRef.putString(driverProfile.cv.url, 'data_url').then((snap) => {
                driverProfile.cv.url = snap.downloadURL;
            });
        }
        catch (e) {
            if (e.code !== "storage/invalid-format") {
                console.log('Error with Uploading');
                console.log(e);
            }
        }

        const newMetadata = {
            contentDisposition: `attachment; filename= Životopis.${driverProfile.cv.extension}`,
        };
        storageRef.updateMetadata(newMetadata);
    }

    return ref.set(driverProfile);
}

export async function getDriverProfileFromFirebase() {
    const user = await FireBaseTools.fetchUser();
    const ref = firebaseDb.ref(`users/${user.uid}/profile`);

    return await new Promise(resolve =>
        ref.once("value", snap =>
            resolve(snap.val())
        )
    );
}

// Cars

export async function getCarsFromFirebase() {
    const ref = firebaseDb.ref('cars');

    return await new Promise(resolve =>
        ref.once("value", snap =>
            resolve(snap.val())
        )
    );
}

export function submitNewCarToFirebase(car) {
    const ref = firebaseDb.ref('cars');

    return ref.push(car);
}

export function updateCarToFirebase(car) {
    const ref = firebaseDb.ref('cars');
    const key = car.key;

    let updates = {};
    updates[key] = {
        'dateAdd': car.dateAdd,
        'name': car.name,
    };

    return ref.update(updates);
}

export function deleteCarFromFirebase(key) {
    const ref = firebaseDb.ref(`cars/${key}`);

    return ref.remove();
}

// Fuel Records

export async function getFuelRecordsFromFirebase() {
    const user = await FireBaseTools.fetchUser();
    const ref = firebaseDb.ref();

    const data = await new Promise(resolve =>
        ref.child(`users/${user.uid}/fuel-records`).once('value', snap => resolve(snap.val()))
    );

    if (!data)
        return [];

    let recordsKeys = [];
    for (const recordKey of Object.keys(data))
        if (data[recordKey])
            recordsKeys.push(recordKey);


    const records = await Promise.all(
        recordsKeys.map(recordKey => ref.child("fuel-records").child(recordKey).once('value'))
    ).then(data => data.map(entry => {
        return entry.val();
    }));

    records.map((record, index) => {
        return _.extend(record, {'key': recordsKeys[index]});
    });

    return records;
}

export async function submitNewRecordToFirebase(record) {
    const ref = firebaseDb.ref();
    const recordKey = ref.push().key;

    const storageRef = firebaseApp.storage().ref(`fuel-records/${recordKey}`);

    await storageRef.putString(record.billPhotoURL, 'data_url').then((snap) => {
        record.billPhotoURL = snap.downloadURL;
    });

    let updates = {};
    updates[`fuel-records/${recordKey}`] = record;

    ref.update(updates);

    return recordKey;
}

export async function deleteFuelRecordFromFirebase(record) {
    const ref = firebaseDb.ref(`fuel-records/${record.key}`);
    const storageRef = firebaseApp.storage().ref(`fuel-records/${record.key}`);

    storageRef.delete();

    return ref.remove();
}

export async function updateFuelRecordToFirebase(record) {
    const ref = firebaseDb.ref();

    const storageRef = firebaseApp.storage().ref(`fuel-records/${record.key}`);

    try {
        await storageRef.putString(record.billPhotoURL, 'data_url').then((snap) => {
            record.billPhotoURL = snap.downloadURL;
        });
    }
    catch (e) {
        if (e.code !== "storage/invalid-format") {
            console.log('Error with Uploading');
            console.log(e);
        }
    }

    let updates = {};

    let cloneRecord = _.extend({}, record);
    delete cloneRecord.key;
    delete cloneRecord.dateAdd;

    Object.keys(cloneRecord).map((key) => {
        updates[`fuel-records/${record.key}/${key}`] = cloneRecord[key];
    });

    ref.update(updates);

    return record.key;
}

export async function getAllFuelRecordsFromFirebase() {
    const ref = firebaseDb.ref('fuel-records');

    const data = await new Promise(resolve =>
        ref.once('value', snap => resolve(snap.val()))
    );

    if (!data)
        return [];

    return Object.keys(data).map((key) => {
        const record = data[key];

        return _.extend(record, {
            key,
        });
    });
}

export async function getAllTrackerUsersWithProfileFromFirebase() {
    const ref = firebaseDb.ref('users');
    const users = await new Promise(resolve =>
        ref.once('value', snap => resolve(snap.val()))
    );

    if (!users)
        return [];

    return Object.keys(users).reduce((array, key) => {
        const user = users[key];

        if (user.profile && user.isTracker) {
            const newUser = _.extend(user.profile, {key});
            array.push(newUser);
        }

        return array;
    }, []);
}

export async function getAllUsersWithProfileFromFirebase() {
    const ref = firebaseDb.ref('users');
    const users = await new Promise(resolve =>
        ref.once('value', snap => resolve(snap.val()))
    );

    if (!users)
        return [];

    return Object.keys(users).reduce((array, key) => {
        const user = users[key];

        let notes;
        if (user.notes)
            notes = Object.keys(user.notes).map((key) => {
                return _.extend(user.notes[key], {key});
            });
        else
            notes = [];

        if (user.profile) {
            const newUser = _.extend(user.profile, {
                created: user.created,
                email: user.email,
                verified: user.verifiedByPierro,
                isActive: user.isActive,
                notes,
                key,
            });
            array.push(newUser);
        }

        return array;
    }, []);
}

export function setVerifiedToUserToFirebase(user, verified) {
    const ref = firebaseDb.ref(`users/${user.key}/verifiedByPierro`);

    return ref.set(verified);
}

export function setIsActiveToUserToFirebase(user, isActive) {
    const ref = firebaseDb.ref(`users/${user.key}/isActive`);

    return ref.set(isActive);
}

export async function addNoteToUserToFirebase(user, note) {
    const ref = firebaseDb.ref(`users/${user.key}/notes`);
    const key = ref.push().key;

    ref.push(note);

    return _.extend({}, note, {key});
}

export function removeNoteFromUserFromFirebase(user, note) {
    const ref = firebaseDb.ref(`users/${user.key}/notes/${note.key}`);

    return ref.remove();
}


// WEBPACK FOOTER //
// ./src/app/helpers/firebase.js